import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getDeedForGoalActions } from './helper';

export default function TreeGoalActions({ data, edit, nestingLevel = 0, onAction }) {
    const initial = useMemo(() => getDeedForGoalActions(data), [data]);
    const [list, setList] = useState(initial.list || {});
    const [nesting, setNesting] = useState(initial.nesting || {});
    const [level, setLevel] = useState(nestingLevel);

    useEffect(() => {
        const next = getDeedForGoalActions(data);
        setList(next.list || {});
        setNesting(next.nesting || {});
    }, [data]);

    const handleDelete = useCallback(
        (e) => {
            const id = e.target.closest('.goal-action-tree__close')?.getAttribute('data-id');
            onAction && onAction(id);
        },
        [onAction]
    );

    const mainClass = useMemo(() => classNames({ 'goal-action': true, 'goal-action_active': edit }), [edit]);
    const titleClass = useCallback(
        (isLast) => classNames({ 'goal-action-tree__title': true, 'goal-action-tree__title_hover': edit && isLast }),
        [edit]
    );

    const renderClose = (id) =>
        edit ? (
            <span className="goal-action-tree__close" data-id={id} onClick={handleDelete}>
        <span className="fa fa-trash-o" />
      </span>
        ) : null;

    const renderTree = (node = list, lvl = 1) => {
        const nextLvl = lvl + 1;
        return (
            <ul className="goal-action-tree">
                {Object.keys(node).map((key) => {
                    const item = node[key];
                    const isList = !!item.list;
                    return (
                        <li className="goal-action-tree__item" key={key}>
                            {!isList && edit ? renderClose(item.idGoalAction) : null}
                            <div className={titleClass(!isList)}>{`(${key}) ${item.title}`}</div>
                            {isList && nesting?.[lvl] ? renderTree(item.list, nextLvl) : null}
                        </li>
                    );
                })}
            </ul>
        );
    };

    return <div className={mainClass}>{renderTree()}</div>;
}

TreeGoalActions.propTypes = {
    data: PropTypes.array,
    edit: PropTypes.bool,
    nestingLevel: PropTypes.number,
    onAction: PropTypes.func,
};
